import React from "react";

import { TITLE_BAR_HEIGHT, hasCustomTitleBar } from "../utils/desktopShell";

/**
 * Gives a full-screen overlay back the window's drag handle.
 *
 * Where the shell suppresses the OS title bar, the app's own toolbar and sidebar
 * carry the drag regions — and a `fixed inset-0` modal covers both. Drag regions
 * resolve against the topmost element, so the backdrop, which declares neither,
 * silently makes the window unmovable for as long as the modal is up. That is a
 * nuisance for a dismissable dialog and a trap for one that cannot be dismissed,
 * like the mandatory update prompt.
 *
 * Sits at z-[5]: above a click-away backdrop (which is z-auto, so the top band
 * drags instead of dismissing — the right call for a title bar) and below the
 * modal card (z-10), whose own controls reach into this band and must keep
 * taking clicks. It opts back into pointer events so it can live in a
 * `pointer-events-none` viewport layer. Overlays hosting this have to place
 * their card accordingly.
 *
 * Inert outside the desktop shell, where the OS draws a real title bar.
 */
const ModalDragStrip = () => {
  if (!hasCustomTitleBar) {
    return null;
  }
  return (
    <div
      aria-hidden="true"
      className="app-drag pointer-events-auto absolute inset-x-0 top-0 z-[5]"
      style={{ height: TITLE_BAR_HEIGHT }}
    />
  );
};

export default ModalDragStrip;
